const googleMapsApiKey = "AIzaSyCfah4vICMLxfhwz5D5hzrInIa7IWkWOaM";

export default googleMapsApiKey;
